// extracted by mini-css-extract-plugin
export default {"location":"Location_location__8HN1y","image":"Location_image__nldY9","text":"Location_text__2rY+e","indications":"Location_indications__wl+XF","content":"Location_content__C5B9h"};